import { Client } from 'src/app/entities/client/client';
import { BaseEntity } from 'src/app/entities/base-entity/base-entity';
import { Permissions } from 'src/app/services/remote-data-service/dtos/project.dto';
import { User } from '../user/user';

/**
 * Class that represents a project in the tracking system.
 *
 * @class Project
 */
export class Project extends BaseEntity {
  /**
   * Creates an instance of Project.
   */
  constructor(
    _uuid: string,
    protected _name: string,
    protected _color: string,
    protected _permissions: Permissions,
    protected _time_spent: number,
    protected _created: Date,
    protected _active: boolean,
    protected _archived: boolean,
    protected _client: Client,
    protected _members?: User[],
    protected _budget?: number
  ) {
    super(_uuid);
  }

  get name(): string {
    return this._name;
  }

  get color(): string {
    return this._color;
  }

  get permissions(): Permissions {
    return this._permissions
  }

  get time_spent(): number {
    return this._time_spent
  }

  get created(): Date {
    return this._created
  }

  get active(): boolean {
    return this._active
  }

  get archived(): boolean {
    return this._archived
  }

  get client(): Client {
    return this._client;
  }

  get members(): User[] | undefined {
    return this._members;
  }

  get budget(): number | undefined {
    return this._budget
  }
}
